// src/serviceWorkerRegistration.js

export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/serviceWorker.js')
        .then((registration) => {
          // console.log('ServiceWorker registration successful with scope: ')
          // console.log('ServiceWorker registration successful with scope: ', registration.scope)
        })
        .catch((err) => {
          console.error('ServiceWorker registration failed: ', err)
        })
    })
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister()
    })
  }
}
